import {PROTOCOL_SLIDE_TYPES, fetchProtocolScene} from '@learningblocks/protocol-constants/lib/Utilities';
import {updateIncorrectsDragDrop, updateSlideInList} from '../../utilities';

export function slideOneDragDrop(state, payload) {
  return {
    ...state,
    protocolSection: updateDesignSection(state.protocolSection, payload),
  };
}

function updateDesignSection(protocolSection, payload) {
  const allSlides = updateAllSlides(protocolSection.allSlides, payload);
  return {
    ...protocolSection,
    allSlides,
  };
}

function updateAllSlides(allSlides, payload) {
  let designSlideOne = fetchProtocolScene(allSlides, PROTOCOL_SLIDE_TYPES.ONE);
  designSlideOne = {
    ...designSlideOne,
    incorrects: updateIncorrectsDragDrop(designSlideOne.incorrects,payload),
    options: updateSlideOptions(designSlideOne.options, payload),
  };
  const updatedSlides = updateSlideInList(allSlides, designSlideOne);
  return updatedSlides;
}

function updateSlideOptions(allOptions, payload) {
  return allOptions.map((option) => {
    if (option.id === payload.positionID) {
      option.droppedId = payload.componentID;
      if (option.id !== payload.componentID) {
        option.wrongDrops += 1;
      }
    }
    return {...option};
  });
}
